'use strict';
import _ from 'lodash';
import Backbone from 'backbone';

export default _.extend({}, Backbone.Events);
